module.exports = __webpack_public_path__ + "img/vector-doa.db3825e7.png";